export const UserSpecialRoleEnum = {
    STUDENT: 'STUDENT',
    BASIC: 'BASIC',
    SATCO: 'SATCO',
    SHIFT_MANAGER: 'SHIFT_MANAGER',
    SUPERINTENDENT: 'SUPERINTENDENT'
};
